import { render, staticRenderFns } from "./VideoListingCard.vue?vue&type=template&id=1d5f526e&"
import script from "./VideoListingCard.vue?vue&type=script&lang=js&"
export * from "./VideoListingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports